import { AppStore } from '@/shared/config/storeConfig/store';

let storeInstance: AppStore | null = null;

export const setStore = (store: AppStore): void => {
  storeInstance = store;
};

export const getStore = (): AppStore | null => storeInstance;


